import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import CategoryDetails from "../screens/CategoryInfoView/CategoryDetails";

const breadCrumbData = [{ link: "/category-info-view", name: "Document" }];
const CategoryManagement = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <CategoryDetails />
    </LayoutContainer>
  </>
);

export default CategoryManagement;